/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2228
 */

module.exports = function (e) {
  return e && "object" === typeof e && "function" === typeof e.copy && "function" === typeof e.fill && "function" === typeof e.readUInt8
}
